module.exports = __webpack_public_path__ + "img/fq0803.prt.66ac5e6a.jpg";